import { createSelector } from 'reselect';
const getProductGroup = (state) => state.productGroup;
export const makeGetProductGroupState = () => createSelector(getProductGroup, (products) => products);
